import React, { useState, useEffect } from 'react';
import { Bell, BellRing } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { notificacaoService } from '../services';
import NotificationModal from './NotificationModal';

const NotificationIcon = () => {
  const { user } = useAuth();
  const [countNaoLidas, setCountNaoLidas] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const carregarContador = async () => {
    if (!user || user.cargo === 'visitante') {
      setCountNaoLidas(0);
      return;
    }

    try {
      setLoading(true);
      const count = await notificacaoService.getCountNaoLidas();
      setCountNaoLidas(count);
    } catch (error) {
      console.error('Erro ao carregar contador de notificações:', error);
      setCountNaoLidas(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarContador();

    // Verificar notificações automáticas quando componente monta
    const verificarNotificacoes = async () => {
      if (user && user.cargo !== 'visitante') {
        try {
          await notificacaoService.verificarAutomaticas();
          carregarContador(); // Recarregar contador após verificação
        } catch (error) {
          console.error('Erro ao verificar notificações automáticas:', error);
        }
      }
    };

    verificarNotificacoes();

    // Configurar intervalo para atualizar contador e verificar notificações
    const interval = setInterval(() => {
      verificarNotificacoes();
    }, 60000); // A cada 1 minuto

    return () => clearInterval(interval);
  }, [user]);

  const handleClick = () => {
    if (user?.cargo !== 'visitante') {
      setShowModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    carregarContador(); // Recarregar contador quando modal fecha
  };

  // Não renderizar para visitantes
  if (!user || user.cargo === 'visitante') {
    return null;
  }

  return (
    <>
      <div
        onClick={handleClick}
        style={{
          position: 'relative',
          cursor: 'pointer',
          padding: '8px',
          borderRadius: '50%',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
        title={`${countNaoLidas} notificações não lidas`}
      >
        {countNaoLidas > 0 ? (
          <BellRing 
            size={24} 
            color="white"
            style={{
              animation: 'bellRing 2s infinite ease-in-out'
            }}
          />
        ) : (
          <Bell 
            size={24} 
            color="white"
          />
        )}

        {countNaoLidas > 0 && (
          <span
            style={{
              position: 'absolute',
              top: '2px',
              right: '2px',
              backgroundColor: '#dc3545',
              color: 'white',
              borderRadius: '50%',
              padding: '2px 6px',
              fontSize: '10px',
              fontWeight: 'bold',
              minWidth: '18px',
              height: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'pulse 2s infinite'
            }}
          >
            {countNaoLidas > 99 ? '99+' : countNaoLidas}
          </span>
        )}

        {loading && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '16px',
              height: '16px',
              border: '2px solid #ccc',
              borderTop: '2px solid #007bff',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}
          />
        )}
      </div>

      <NotificationModal 
        isOpen={showModal}
        onClose={handleModalClose}
      />
    </>
  );
};

export default NotificationIcon;